module.exports = __webpack_public_path__ + "static/media/logo.2bb7da65.svg";